import { useEffect, useRef } from "react";

/**
 
 * @param {object} data 
 * @param {function} onSave 
 * @param {number} delay 
 */
export function useAutoSave(data, onSave, delay = 5000) {
  const timerRef = useRef(null);
  const firstRun = useRef(true);

  useEffect(() => {
    
    if (firstRun.current) {
      firstRun.current = false;
      return;
    }

    
    if (timerRef.current) clearTimeout(timerRef.current);

    
    timerRef.current = setTimeout(() => {
      if (typeof onSave === "function") {
        onSave(data);
      } else {
        console.warn("⚠️ useAutoSave: onSave is not a function", onSave);
      }
    }, delay);

    
    return () => clearTimeout(timerRef.current);
  }, [data, onSave, delay]);
}